import { type ApprovalRollupSignal } from "@mg/schemas/src/christo/approvalEvent";

/** Human-readable advisory rollup copy (never a gate). */
export function approvalRollupLabel(signal: ApprovalRollupSignal): string {
  switch (signal) {
    case "no_activity":
      return "No activity";
    case "awaiting_input":
      return "Awaiting input";
    case "in_discussion":
      return "In discussion";
    case "changes_requested":
      return "Changes requested";
    case "looks_approved":
      return "Looks approved";
    default: {
      const _exhaustive: never = signal;
      return _exhaustive;
    }
  }
}
